const isAutoAdded = createdBy => createdBy === 'AUTOMATION SERVICE';
const isStory = type => type === 'stories';

module.exports = { isAutoAdded, isStory };



/** WEBPACK FOOTER **
 ** ./src/utils/automation-utils.js
 **/